<template>
  <div class="users-list" v-loading="loading">
    <el-input placeholder="Поиск ..." v-model="search" class="input-search">
      <el-button slot="append" icon="el-icon-search"></el-button>
    </el-input>

    <el-table
      :data="users"
      style="width: 100%"
    >
      <el-table-column
        width="200"
        prop="email"
        label="Email"
      >
        <template slot-scope="scope">
          <router-link :to="`/dashboard/clients/${scope.row.uid}`">
            {{ scope.row.email }}
          </router-link>
        </template>
      </el-table-column>
      <el-table-column
        width="200"
        prop="name"
        label="Name"
      >
      </el-table-column>
      <el-table-column
        width="100"
        prop="phone"
        label="Phone"
      >
      </el-table-column>
      <el-table-column
        width="150"
        prop="company"
        label="Company"
      >
      </el-table-column>
      <el-table-column
        prop="start_date"
        label="Start date"
      >
        <template slot-scope="scope">
          <span>{{ dayjs(scope.row.start_date * 1000).format('YYYY-MM-DD') }}</span>
        </template>
      </el-table-column>
      <el-table-column
        width="170"
        prop="end_date"
        label="End date"
      >
        <template slot-scope="scope">
          <date-picker
            format="YYYY-MM-DD"
            style="width: 140px"
            ref="datePicker"
            @input="(e) => changeTime(e, scope.row.uid)"
            v-model="scope.row.end_date"
          ></date-picker>
        </template>
      </el-table-column>
      <el-table-column
        prop="companies"
        label="Созданых проектов"
      >
      </el-table-column>
      <el-table-column
        label="Приглашенный"
      >
        <template slot-scope="scope">
          <span class="is-invited">{{ scope.row.isInvited ? '+' : '-' }}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import AddProject from '@/views/Dashboard/Projects/components/AddProject';
import firebase from 'firebase';
import DatePicker from 'vue2-datepicker';
import dayjs from 'dayjs';
import _ from 'lodash';

export default {
  name: 'List',
  components: {AddProject, DatePicker},
  data() {
    return {
      search: '',
      loading: false,
      users: [],
      invites: [],
      rules: {
        'worker': 'Стандартный',
        'admin': 'Админ',
        'editor': 'Редактор',
      },
    };
  },

  mounted() {
    firebase.firestore().collection('superuser').where('user', '==', firebase.auth().currentUser.uid).get()
      .then(async (data) => {
        if (data.size) {
          this.fetchUsers();
        } else {
          this.$router.push('/');
        }
      });
  },

  methods: {
    async changeTime(input, uid) {
      const projects = await firebase.firestore()
        .collection('projects')
        .where(`owner`, '==', uid)
        .get();

      const batch = firebase.firestore().batch();
      projects.forEach(doc => {
        batch.update(doc.ref, {
          ...doc.data(),
          end_date: dayjs(input).utc().unix(),
        });
      });

      await batch.commit();
    },
    dayjs,
    fetchUsers: function () {
      this.loader = true;
      const result = [];
      const users_result = [];
      const projects_data = [];
      firebase.firestore().collection('projects').get().then(async (data) => {
        data.forEach((sub) => {
          const data = sub.data();
          result.push({
            id: sub.id,
            owner: data.owner,
            start_date: data.start_date,
            phone: data.phone,
            end_date: new Date(data.end_date * 1000),
          });
        });
      }).finally(async () => {
        const promises = [];
        for (let project_id of result) {
          if (project_id.owner) {
            projects_data.push(project_id);
            promises.push(firebase.firestore()
              .collection('projects')
              .doc(project_id.id)
              .collection('users')
              .where('uid', '==', project_id.owner).get());
          }
        }

        Promise.all(promises).then((all_users) => {
          all_users.forEach((users, key) => {
            users.forEach((data) => {
              const user = data.data();
              const isset_user = users_result.findIndex((u) => user.uid === u.uid);
              if (isset_user !== -1) {
                users_result[isset_user].start_date = projects_data[key].start_date;
                users_result[isset_user].end_date = projects_data[key].end_date;
                users_result[isset_user].companies += 1;
                if (user.isInvited) {
                  users_result[isset_user].isInvited = true;
                }
              } else {
                users_result.push({
                  ...data.data(),
                  start_date: projects_data[key].start_date,
                  end_date: projects_data[key].end_date,
                  companies: 1,
                });
              }
            });
          });

          this.users =  _.orderBy(users_result, 'start_date', ['desc']);
        });
      });
    },
  },
  computed: {
    filteredList() {
      return this.users.filter(user => {
        return user.name.toLowerCase().includes(this.search.toLowerCase());
      });
    },
  },
};
</script>

<style scoped lang="scss">
.users-list {
  max-width: 1400px;
  width: calc(100% - 40px);
  margin: 22px auto;
}

.input-search {
  margin-top: 12px;
}

.name {
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  small {
    font-size: 12px;
    font-weight: bold;
  }
}

.users-ul {
  display: flex;
  flex-direction: column;
  margin-top: 10px;

  .users-li, > > > .users-li {
    align-items: center;
    display: flex;
    justify-content: space-between;
    height: 64px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.18);
    cursor: pointer;
    padding: 0 12px;


    &.active {
      background: rgba(54, 118, 203, 0.26) !important;
    }

    &:hover {
      background: #f0f0f0;
    }

    &:last-child {
      border-bottom: none;
    }
  }
}

.add-user {
  margin-top: 22px;
  text-decoration: none;
  color: #3676CB;

  &:hover {
    color: #222;
  }
}

.controls {
  margin-top: 30px;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
}

.users-invites {
  margin-top: 20px;

  .name, .email {
    opacity: 0.5;
  }
}

.users-controls {
  display: flex;
  justify-content: flex-end;

  i {
    margin-left: 16px;
  }
}

.is-invited {
  font-size: 18px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/views/Admin/Clients/List.vue